import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "SubmitReviewModalContentBlock" }
const _hoisted_2 = { class: "SubmitReviewModalButtons" }
const _hoisted_3 = { class: "SubmitReviewModalContentBlock" }
const _hoisted_4 = { class: "SubmitReviewModalButtons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "modalContent",
    class: _normalizeClass([
			'SubmitReviewModal',
			_ctx.modalStatusIsConfirmation ? 'SubmitReviewConfirmationModal' : 'SubmitReviewLaterModal'
		])
  }, [
    (_ctx.modalStatusIsConfirmation)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "SubmitReviewModalHeaderBlock" }, [
            _createElementVNode("h3", null, "Submit review")
          ], -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_1, [
            _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"SubmitReviewConfirmationIcon\"><img src=\"https://monet-prtl-co.imgix.net/Endor/ERT/celebration.png\"></div><p class=\"SubmitReviewConfirmationText\"> It looks like you reviewed all enrolments from this organisation. Would you like to submit now? </p><div class=\"SubmitReviewConfirmationNote\"><i class=\"lnr-info SubmitReviewConfirmationNoteIcon\"></i><div class=\"SubmitReviewConfirmationNoteTextContainer\"><p class=\"SubmitReviewConfirmationNoteText\"> Note: After you submit, you won’t be able to make changes to these enrolments. </p><p class=\"SubmitReviewConfirmationNoteText\"> We will get in touch with you shortly to discuss the results and any questions you might have. </p><p class=\"SubmitReviewConfirmationNoteText\"> The review inputs will be used to calculate and invoice the enrolment success fees. </p></div></div>", 3)),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("button", {
                class: "DriverButton SubmitReviewButton",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.triggerSubmitReview && _ctx.triggerSubmitReview(...args)))
              }, " Submit review "),
              _createElementVNode("button", {
                class: "NavigatorButton",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showSubmitReviewLaterModal && _ctx.showSubmitReviewLaterModal(...args)))
              }, " I want to submit later ")
            ])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : (_ctx.modalStatusIsLater)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "SubmitReviewModalHeaderBlock" }, [
              _createElementVNode("h3", null, "Submit review")
            ], -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_3, [
              _cache[5] || (_cache[5] = _createElementVNode("img", {
                class: "SubmitReviewLaterModalImage",
                src: "https://monet-prtl-co.imgix.net/Endor/ERT/orange-submit-review-button-indication.svg"
              }, null, -1 /* CACHED */)),
              _cache[6] || (_cache[6] = _createElementVNode("p", { class: "SubmitReviewLaterModalText" }, [
                _createTextVNode(" Whenever you are ready... Just use the "),
                _createElementVNode("strong", null, "Submit review"),
                _createTextVNode(" button. ")
              ], -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  class: "NavigatorButton",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hideModal && _ctx.hideModal(...args)))
                }, " Got it ")
              ])
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}